var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"d":"M26,19.7v-.05l0,.05Z","key":0}),React.createElement("path",{"d":"M23.7,0A23.7,23.7,0,1,0,47.4,23.7,23.7,23.7,0,0,0,23.7,0Zm-6,33.51H12.29V17.36h5.37ZM15,15.15h0A2.8,2.8,0,1,1,15,9.57a2.8,2.8,0,1,1,0,5.58ZM37,33.51H31.66V24.87c0-2.17-.78-3.65-2.72-3.65a2.94,2.94,0,0,0-2.76,2A3.74,3.74,0,0,0,26,24.49v9H20.63s.07-14.64,0-16.15H26v2.29A5.35,5.35,0,0,1,30.85,17C34.38,17,37,19.29,37,24.25Z","key":1})])));
}

Linkedin.defaultProps = {"viewBox":"0 0 47.4 47.4"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
